module.exports = __webpack_public_path__ + "img/none.e9765225.png";